import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';

export const Overlay = styled.View`
  flex: 1;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
`;

export const ModalCard = styled.View`
  width: 85%;
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(16)}px;
  padding: ${RFValue(28)}px ${RFValue(24)}px;
  align-items: center;
`;

export const IconWrapper = styled.View`
  width: ${RFValue(64)}px;
  height: ${RFValue(64)}px;
  border-radius: ${RFValue(32)}px;
  background-color: ${({theme}) => theme.colors.info_bg};
  align-items: center;
  justify-content: center;
  margin-bottom: ${RFValue(16)}px;
  align-items: center;
  justify-content: center;
  margin-bottom: ${RFValue(20)}px;
`;

export const Icon = styled(Feather)`
  font-size: ${RFValue(28)}px;
  color: ${({theme}) => theme.colors.info_icon};
`;

export const Title = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.title};
  margin-bottom: ${RFValue(12)}px;
  text-align: center;
`;

export const Description = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(13)}px;
  color: ${({theme}) => theme.colors.text};
  text-align: center;
  line-height: ${RFValue(22)}px;
  margin-bottom: ${RFValue(24)}px;
`;

export const ActionButton = styled.TouchableOpacity`
  width: 100%;
  height: ${RFValue(44)}px;
  background-color: ${({theme}) => theme.colors.primary};
  border-radius: ${RFValue(8)}px;
  align-items: center;
  justify-content: center;
`;

export const ActionButtonText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(14)}px;
  color: #ffffff;
`;
